import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import { translateStaticContent } from '../../../helpers/translateStaticContent';

const SectionAdvantages = (props) => {
    return(
       <div className="container advantages">
           <div className="adv-info">
               <div className="info">
                <h2>
                    {translateStaticContent('whyWelsendHeading', 
                        props.defaultStaticContentMainPage, props.activeLangStaticContentMainPage)}
                </h2>
                    <p>
                        {translateStaticContent('whyWelsendText', 
                            props.defaultStaticContentMainPage, props.activeLangStaticContentMainPage)}
                    </p>
                    <NavLink to='/aboutSystem' rel="noreferrer">
                         {translateStaticContent('whyWelsendBtn', 
                            props.defaultStaticContentMainPage, props.activeLangStaticContentMainPage)}
                    </NavLink>
               </div>   
           </div>
           <div className="tabs">
               <div className="item">
                   <span className="simple"></span>
                   <div className="item-header">
                        {translateStaticContent('whyWelsendB1Heading', 
                            props.defaultStaticContentMainPage, props.activeLangStaticContentMainPage)}
                   </div>
                   <p>
                        {translateStaticContent('whyWelsendB1Text', 
                            props.defaultStaticContentMainPage, props.activeLangStaticContentMainPage)}
                   </p>
               </div>
               <div className="item">
                   <span className="cheap"></span>
                   <div className="item-header">
                        {translateStaticContent('whyWelsendB2Heading', 
                            props.defaultStaticContentMainPage, props.activeLangStaticContentMainPage)}
                   </div>
                   <p>
                        {translateStaticContent('whyWelsendB2Text', 
                            props.defaultStaticContentMainPage, props.activeLangStaticContentMainPage)}
                   </p>
               </div>
               <div className="item item-additional">
                   <span className="globe"></span>
                   <div className="item-header">
                        {translateStaticContent('whyWelsendB3Heading', 
                            props.defaultStaticContentMainPage, props.activeLangStaticContentMainPage)}
                   </div>
                   <p>
                        {translateStaticContent('whyWelsendB3Text', 
                            props.defaultStaticContentMainPage, props.activeLangStaticContentMainPage)}
                   </p>
               </div>
               <div className="item item-additional">
                   <span className="partnership"></span>
                   <div className="item-header">
                        {translateStaticContent('whyWelsendB4Heading', 
                            props.defaultStaticContentMainPage, props.activeLangStaticContentMainPage)}
                   </div>
                   <p>
                        {translateStaticContent('whyWelsendB4Text', 
                            props.defaultStaticContentMainPage, props.activeLangStaticContentMainPage)}
                   </p>
               </div>
            </div>   
       </div>
    )
}

export default SectionAdvantages;

SectionAdvantages.propTypes = {
    defaultStaticContentMainPage: PropTypes.object,
    activeLangStaticContentMainPage: PropTypes.object,
}